/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as rewardPointsActions from './RewardPoints-Actions';
import * as rewardPointsOperations from './RewardPoints-Operations';
import rewardPointsReducer from './RewardPoints-Reducer';

const rewardPointsWatcherSagas = [
    ...rewardPointsOperations.watchers,
];

export {
    rewardPointsActions,
    rewardPointsOperations,
    rewardPointsWatcherSagas,
};

export default rewardPointsReducer;
